function EmptyComponent() {
  return <div>No marketplaces to display</div>;
}

export default EmptyComponent;
